<template>
   <div class="heading">
     <h1><slot></slot></h1>
  </div>
</template>

<script src="./script.js"></script>
<style src="./style.less" lang="less"></style>
